import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <>
      <div className="bg-red-900">
        <div className="footer sm:footer-horizontal text-white p-8 py-10 max-w-screen-2xl mx-auto flex flex-col md:flex-row md:justify-between items-center">
          <aside className="md:w-1/2">
            <div>
              <p className="text-lg font-black">
                INDONESIA ULTRA24
              </p>
              <p className="lg:max-w-3xl text-base mt-2 opacity-90">
                Indonesia Ultra is a 24-hour community running event that combines social runs, educational sessions, challenges, and recovery.
                We build an inclusive experience for runners from beginners to experienced with safe and structured event standards.
              </p>
            </div>
          </aside>

          <div className="mt-8 md:mt-0">
            <Link
              to="/"
              className="flex items-center"
            >
              <img
                src="/logo/logowhite.svg"
                alt="Ultra24 Logo"
                className="h-24 w-auto"
              />
            </Link>
          </div>
        </div>
      </div>

      <footer className="footer sm:footer-horizontal footer-center bg-white text-base-content p-6">
        <aside>
          <p className="text-sm font-medium">
            Copyright © 2026 - ULTRA24. All rights reserved PT. Cakrawala Jakarta Kreatif
          </p>
        </aside>
      </footer>
    </>
  );
};
